exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".orderlist-table{line-height:33.59px}.orderlist-table .header{margin-bottom:10px}.orderlist-table .body .Row{padding:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/pages/orderlist/OrderlistPage.scss
// module id = 749
// module chunks = 0